const reviews = [
  {
    name: "Sandra M.",
    city: "Zürich",
    service: "Umzug · 3-Zimmer Wohnung",
    rating: 5,
    text: "Pünktlich, freundlich und super organisiert. Unser Umzug lief ohne Stress und alle Möbel sind unbeschädigt angekommen. Klare Empfehlung!",
  },
  {
    name: "Daniel K.",
    city: "Winterthur",
    service: "Endreinigung mit Abnahmegarantie",
    rating: 5,
    text: "Die Endreinigung war top – die Wohnungsabgabe hat ohne Beanstandung geklappt. Das Team war sehr gründlich und zuverlässig.",
  },
  {
    name: "Elena R.",
    city: "Uster",
    service: "Büroumzug",
    rating: 5,
    text: "Unser Büro wurde an einem Wochenende komplett umgezogen. Am Montag konnten wir sofort weiterarbeiten. Sehr professionell und fair im Preis.",
  },
];

export default reviews;